export const moodColor = (m) => {
  if (m >= 9) return "var(--mm-success)";
  if (m >= 7) return "#81C784";
  if (m >= 5) return "var(--mm-warning)";
  if (m >= 3) return "#FF8A65";
  return "var(--mm-error)";
};

export const moodEmoji = (m) => {
  if (m >= 9) return "😊";
  if (m >= 7) return "🙂";
  if (m >= 5) return "😐";
  if (m >= 3) return "😔";
  return "😢";
};

export const moodLabel = (m) => {
  if (m >= 9) return "Excellent";
  if (m >= 7) return "Good";
  if (m >= 5) return "Okay";
  if (m >= 3) return "Low";
  return "Struggling";
};

export const greeting = () => {
  const h = new Date().getHours();
  if (h < 12) return { text: "Good morning", emoji: "☀️" };
  if (h < 17) return { text: "Good afternoon", emoji: "🌤️" };
  if (h < 21) return { text: "Good evening", emoji: "🌅" };
  return { text: "Good night", emoji: "🌙" };
};

export const fmtDate = (d, opts = { month: "short", day: "numeric" }) =>
  new Date(d).toLocaleDateString("en-US", opts);
export const fmtTime = (d) =>
  new Date(d).toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });

export const toUtc = (s) => (s && !/[zZ]|[+-]\d\d:\d\d$/.test(s) ? `${s}Z` : s);
